"use client"
import React from "react";
import Accordion from "react-bootstrap/Accordion";

const Instructions = () => {
  return (
    <>
      <div className="flex flex-col items-center text-center px-4">
        <img
        src="./Shopify_Connector.svg"
        className="img-fluid w-75 d-block mx-auto rounded my-5"
      />
      </div>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="my-4">
          <Accordion.Header>1. Configuration</Accordion.Header>
          <Accordion.Body className="List-Items px-5 py-4">
            <ul>
              <li>Log into PIM. Create a new API connection or identify an existing one for use by the connector.</li>
              <li>Go to the Connector app. In the &quot;Connection&quot; section, provide PIM API credentials. Click &quot;Save Config&quot;.</li>
              <li>Click &quot;Test PIM Connection&quot; button to verify if the API connection is established successfully.</li>
              <li>In the &quot;Data Filters&quot; section, define what products to import from PIM by specifying filters including Channel, Locale, Completeness, and more. Click &quot;Save Config&quot;.</li>
              <li>In the &quot;Mapping&quot; section, map which PIM attributes should be transferred to which Shopify fields (product and variant attributes, image attributes, and metafields).</li>
              <li>In the &quot;Additional Mapping&quot; section, indicate if images must be transferred to Shopify. Click &quot;Save Config&quot;.</li>
              <li>Proceed to the &quot;Data Sync&quot; tab.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" className="my-4">
          <Accordion.Header>2. Data Sync</Accordion.Header>
          <Accordion.Body className="List-Items px-5 py-4">
            <ul>
            <li>To transfer PIM categories to Shopify, open &quot;Category (Collection) Sync&quot; section and click on &quot;Sync Categories&quot;. A Request ID will be generated and displayed.</li>
            <li>Click on the generated Request ID to view details of the category sync in progress.</li>
            <li>You can monitor details including record type, sync status, sync counts, and errors. You can also download error logs or cancel the sync job in progress.</li>
            <li>After the sync completes, you can verify that the PIM categories are transferred as Collections in Shopify.</li>
            <li>To transfer PIM products to Shopify, open &quot;Product Sync&quot; section and click on &quot;Sync Products&quot;. A Request ID will be generated and displayed.</li>
            <li>Click on the generated Request ID to view details of the product sync in progress.</li>
            <li>You can monitor details including record type, sync status, sync counts, and errors. You can also download error logs or cancel the sync job in progress.</li>
            <li>After the sync completes, you can verify that the PIM products, variants, and associated media are transferred into Shopify correctly.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2" className="mt-4">
          <Accordion.Header>3. Sync Status</Accordion.Header>
          <Accordion.Body className="List-Items px-5 py-4">
            <ul>
              <li>Monitor the status of your sync jobs.</li>
              <li>Note: Status is refreshed on the screen every 10 seconds.</li>
              <li>Click on &quot;Download&quot; to review any available error reports.</li>
              <li>Click on the &quot;X&quot; red button to abort the associated sync job.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3" className="mt-4">
          <Accordion.Header>4. PIM2Shopify Link Reset</Accordion.Header>
          <Accordion.Body className="List-Items px-5 py-4">
            <p><strong>Deleting Shopify Collections</strong></p>
            <ul>
              <li>If you must delete a collection in Shopify, follow this process so you can successfully re-sync that category from PIM into Shopify.</li>
              <li>Go to the &quot;Category Reset&quot; section. Enter the ID of the Shopify Collection you want to delete. You may enter multiple Collection IDs as a comma separated list of IDs.</li>
              <li>Click Reset Category Link. This will delete the associated connector link entries. Now you may successfully re-sync that category from PIM into Shopify again without errors.</li>
            </ul>
            <p><strong>Deleting Shopify Products</strong></p>
            <ul>
              <li>If you must delete a product in Shopify, follow this process so you can successfully re-sync that product from PIM into Shopify.</li>
              <li>Go to the &quot;Product Reset&quot; section. Enter the ID of the Shopify Product you want to delete. You may enter multiple Product IDs as a comma separated list of IDs.</li>
              <li>Click Reset Product Link. This will delete the associated connector link entries. Now you may successfully re-sync that product from PIM into Shopify again.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default Instructions;